import clsx from "clsx";
import useAppBarHeader from "./hook/useAppBarHeader";
import { AppBarHeaderRoot, AppBarWrapper, MainHeader } from "./AppBarHeader.styles";
import { Divider } from "@commonlibs";
import AppBarHeaderTitle from "./AppBarHeaderTitle";
import AppHeaderThemeProvider from "./AppHeaderThemeProvider";
import AccountCard from "ui/wallet/containers/AccountCard/AccountCard";

export interface AppBarHeaderProps {
    className?: string;
    style?: React.CSSProperties;
    onLeftClick?: () => void;
}

function AppBarHeader({ className, onLeftClick: onLeftClickProp, ...rest }: AppBarHeaderProps) {
    const { onLeftClick, left, hide } = useAppBarHeader({ onLeftClick: onLeftClickProp });

    return (
        <AppHeaderThemeProvider>
            {hide ? null : (
                <AppBarHeaderRoot>
                    <AppBarWrapper>
                        <MainHeader
                            className={clsx("app-bar-header", className)}
                            right="support"
                            onLeftClick={onLeftClick}
                            left={left}
                            center={<AppBarHeaderTitle />}
                            {...rest}
                        />
                        <Divider style={{height: "2px"}}/>
                        <AccountCard />
                    </AppBarWrapper>
                </AppBarHeaderRoot>
            )}
        </AppHeaderThemeProvider>
    );
}

export default AppBarHeader;
